<template>
  <el-dialog :visible.sync="dialogFormVisible" center width="60%" class="addMain" :close-on-click-modal=false>
    <h3 slot="title" class="bb pb20">{{ docInfo.hosName }}门诊病历</h3>
    <ul class="color_333 fs14 addUl">
      <li class="flex" style="width: 100%">
        <p class="width33">姓名：{{ info.compatName }}</p>
        <p class="width33">性别：{{ info.compatGender|sexFilter }}</p>
        <p class="width33">年龄：{{ info.compatAge }}</p>
      </li>
      <li class="flex space-between">
        <p class="width33">科别：{{ info.bookDeptName }}</p>
        <p class="width33">出生日期：{{ birthday }}</p>
        <p class="width33">就诊时间：{{ jzsj }}</p>
      </li>
      <li class="flex aic">
        <span class="pr15">就诊类型：</span>
        <!--                <el-radio v-model="outpatientType" label="1" :disabled="disabled">初诊</el-radio>-->
        <el-radio v-model="outpatientType" label="2" :disabled="disabled">复诊</el-radio>
      </li>
      <li class="flex space-between addRecord">
        <p class="flex1 flex aic">
          <span class="flex0 width15">诊断:</span>
          <span class="flex1">
                      <el-autocomplete
                          class="el-input el-input--large"
                          size="large"
                          :disabled="disabled"
                          :placeholder="placeholder"
                          v-model="diagnosis.diagnosisName"
                          :fetch-suggestions="fetchDiagnosis"
                          @blur="blurDiagnosis"
                          @select="(item)=>{selectDiagnose(item)}"
                          @keydown.native="deleteDiagnosis"
                      ></el-autocomplete>
                </span>
        </p>
        <p class="flex1 flex aic">
          <span class="flex0 width20 right pl20">过敏史:</span>
          <el-input v-model="allergyHistory" :placeholder="placeholder"
                    :disabled="disabled" maxlength="200" show-word-limit></el-input>
        </p>
      </li>
      <li class="flex aic">
        <span class="flex0 width7">症状:</span>
        <el-input v-model="diagnosis.symptomsName" type="textarea" :rows="2" show-word-limit
                  :placeholder="placeholder" :disabled="disabled" maxlength="30"></el-input>
        <!--<el-autocomplete
                class="el-input el-input&#45;&#45;large"
                size="large"
                :maxlength=500 show-word-limit
                :disabled="disabled"
                :placeholder="placeholder"
                v-model="diagnosis.symptomsName"
                :fetch-suggestions="fetchSymptoms"
                @blur="blurSymptoms"
                @select="(item)=>{selectSymptoms(item)}"
                @keydown.native="deleteSymptoms"
        ></el-autocomplete>-->
      </li>
      <li class="flex aic">
        <span class="flex0 width7">主诉:</span>
        <el-input v-model="diseaseDescription" type="textarea" :rows="2" show-word-limit
                  :placeholder="placeholder" :disabled="disabled" maxlength="200"></el-input>
      </li>
      <li class="flex aic">
        <span class="flex0 width7">现病史:</span>
        <el-input v-model="nowHistory" type="textarea" :rows="2" :placeholder="placeholder"
                  :disabled="disabled" maxlength="200" show-word-limit></el-input>

      </li>
      <li class="flex aic">
        <span class="flex0 width7">既往史:</span>
        <el-input v-model="pastHistory" type="textarea" :rows="2" :placeholder="placeholder"
                  :disabled="disabled" maxlength="200" show-word-limit></el-input>
      </li>
      <li>医师：<span class="pl15">{{ info.bookDocName || info.ysmc || docInfo.docName }}</span></li>
      <li style="text-align: center" v-if="!disabled">
        <el-button type="primary" @click="submit">确认提交</el-button>
      </li>
    </ul>
  </el-dialog>
</template>

<script>
import {timeFormat, sex} from "ty-vue-filters";
import {sexFilter, getBirthdayFromIdCardFilter, schdateFilter} from "../../lib/filters";
import {tokenCache} from "../../lib/cache/Token";

export default {
  name: "add-medical-record",
  props: {
    inputDisabled: {
      type: Boolean,
      default: false
    },
    datas: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      info: {},
      disabled: false, //输入框是否可编辑
      diagnosis: {
        diagnosisCode: '', //诊断代码，多个用 ; 分割
        diagnosisName: '', //诊断名称，多个用 ; 分割
        symptomsCode: '', //症状代码，多个用 ; 分割
        symptomsName: '', //症状名称，多个用 ; 分割
      },
      diagnosisTemp: {
        diagnosisCode: '', //诊断代码，多个用 ; 分割
        diagnosisName: '', //诊断名称，多个用 ; 分割
        symptomsCode: '', //症状代码，多个用 ; 分割
        symptomsName: '', //症状名称，多个用 ; 分割
      },
      allergyHistory: '',//过敏史
      outpatientType: '2',//就诊类型 1-初诊，2-复诊
      diseaseDescription: '', //主诉
      nowHistory: '',//现病史
      pastHistory: '',//既往史
      dialogFormVisible: false,
      diagnosisAllList: [],
    }
  },
  filters: {
    sexFilter,
    timeFormat,
    getBirthdayFromIdCardFilter,
    filter_date(str) {
      return timeFormat(str, '%Y-%m-%d');
    },
    filter_czsj(str) {
      return str.slice(0, 10)
    }
  },
  computed: {
    placeholder() {
      return this.disabled ? '无' : '请输入内容'
    },
    birthday() {
      let compatIdcard = this.info.compatIdcard || "";
      if (compatIdcard) {
        return getBirthdayFromIdCardFilter(compatIdcard, true);
      }
      let compatBirthday = this.info.compatBirthday || this.info.birthday;
      if (compatBirthday && typeof compatBirthday === "number") {
        return timeFormat(compatBirthday, '%Y-%m-%d');
      }
      return compatBirthday;
    },
    ddxx() {
      const {ddxx = {}} = this.info;
      if (ddxx.code === '0') return ddxx.obj;
      return {}
    },
    // 就诊时间
    jzsj() {
      const {ddxx, info} = this;
      if (ddxx.jzrq) return schdateFilter(ddxx.jzrq)
      return info.ghrq;
    }
  },
  async created() {
    if (this.disabled) {
      this.initHisRecord()
    } else {
      await this.getDiagnosisAllList()
    }
  },
  methods: {
    initHisRecord() {
      let info = this.info
      this.diagnosis.diagnosisName = info.diagnosisName
      this.diagnosis.symptomsName = info.symptomsName
      this.allergyHistory = info.allergyHistory
      this.outpatientType = info.outpatientType
      this.diseaseDescription = info.diseaseDescription
      this.nowHistory = info.nowHistory
      this.pastHistory = info.pastHistory
    },
    async getDiagnosisAllList() {
      if (!this.info.compatName) {
        ////////////////////////////
        this.info = this.info.ddxx ? this.info.ddxx.obj : {}
      }
      let {code, list} = await this.$http("smarthos.recipe.diagnosis.list", {
        key: '',
        token: tokenCache.get(),
      })
      if (code === '0') {
        this.diagnosisAllList = list
      }
    },
    //选择诊断相关操作
    blurDiagnosis() {
      let name = this.diagnosis.diagnosisName
      if (name.substr(name.length - 1, 1) === '；') return
      let list = this.diagnosis.diagnosisName.split('；')
      let re = list.slice(0, list.length - 1)
      let res = re.length >= 1 ? re.join("；") + '；' : re.join("；")
      this.diagnosis.diagnosisName = res
      this.diagnosisTemp.diagnosisName = this.diagnosis.diagnosisName
    },
    async fetchDiagnosis(queryString, cb) {
      let newQuery = queryString + '；'
      if (newQuery === this.diagnosisTemp.diagnosisName) {
        queryString = newQuery
        this.diagnosis.diagnosisName = this.diagnosisTemp.diagnosisName
      }
      const index = queryString.lastIndexOf('；')
      const key = queryString.substring(index + 1, queryString.length);
      const options = {
        diagnosis: key,
        token: tokenCache.get(),
      }
      let {code, list} = await this.$http("smarthos.recipe.diagnosis.list", options)
      if (code == '0') {
        for (let i of list) {
          i.value = i.diagnosis; //必须绑定value值作为显示数据
        }
        cb(list);
      }
    },
    selectDiagnose(item) {
      console.log('之前的诊断===', this.diagnosisTemp.diagnosisName, this.diagnosisTemp.diagnosisCode)
      console.log('选择后的诊断===', item)
      if (this.diagnosisTemp.diagnosisName != '') {
        let n = this.diagnosisTemp.diagnosisName.split('；').length
        //限制诊断数量
        if (n < 200) {
          this.diagnosisTemp.diagnosisName = this.diagnosisTemp.diagnosisName + item.diagnosis + '；'
          this.diagnosisTemp.diagnosisCode = this.diagnosisTemp.diagnosisCode + item.diagnosisCode + '；'
        } else {
          this.$message.error('输入诊断数量不能超过5个！')
        }
      } else {
        this.diagnosis.diagnosisCode = item.diagnosisCode
        this.diagnosisTemp.diagnosisName = this.diagnosis.diagnosisName = this.diagnosis.diagnosisName + '；'
        this.diagnosisTemp.diagnosisCode = this.diagnosis.diagnosisCode = this.diagnosis.diagnosisCode + '；'
      }
      this.diagnosis.diagnosisName = this.diagnosisTemp.diagnosisName
      this.diagnosis.diagnosisCode = this.diagnosisTemp.diagnosisCode
    },
    deleteDiagnosis(e) {
      if (e.keyCode == 8) {
        const o = this.diagnosis.diagnosisName.split('；')
        const p = this.diagnosis.diagnosisCode.split('；')
        o.splice(o.length - 2, 2)
        p.splice(p.length - 2, 2)
        let n = o.length >= 1 ? o.join("；") + '；' : o.join("；")
        let s = p.length >= 1 ? p.join("；") + '；' : p.join("；")
        this.diagnosis.diagnosisName = this.diagnosisTemp.diagnosisName = n
        this.diagnosis.diagnosisCode = this.diagnosisTemp.diagnosisCode = s
      }
    },

    //选择症状相关操作
    blurSymptoms() {
      let name = this.diagnosis.symptomsName
      if (name.substr(name.length - 1, 1) === '；') return
      let list = this.diagnosis.symptomsName.split('；')
      let re = list.slice(0, list.length - 1)
      let res = re.length >= 1 ? re.join("；") + '；' : re.join("；")
      this.diagnosis.symptomsName = res
      this.diagnosisTemp.symptomsName = this.diagnosis.symptomsName
    },
    async fetchSymptoms(queryString, cb) {
      let newQuery = queryString + '；'
      if (newQuery === this.diagnosisTemp.symptomsName) {
        queryString = newQuery
        this.diagnosis.symptomsName = this.diagnosisTemp.symptomsName
      }
      const index = queryString.lastIndexOf('；')
      const key = queryString.substring(index + 1, queryString.length);
      const options = {
        symptoms: key,
        token: tokenCache.get(),
      }
      let {code, list} = await this.$http("smarthos.supervision.dict.symptoms", options)
      if (code == '0') {
        for (let i of list) {
          i.value = i.name; //必须绑定value值作为显示数据
        }
        cb(list);
      }
    },
    selectSymptoms(item) {
      console.log('之前的诊断===', this.diagnosisTemp.symptomsName, this.diagnosisTemp.symptomsCode)
      console.log('选择后的诊断===', item)
      if (this.diagnosisTemp.symptomsName !== '') {
        this.diagnosisTemp.symptomsName = this.diagnosisTemp.symptomsName + item.name + '；'
        this.diagnosisTemp.symptomsCode = this.diagnosisTemp.symptomsCode + item.code + '；'

      } else {
        this.diagnosis.symptomsCode = item.code
        this.diagnosisTemp.symptomsName = this.diagnosis.symptomsName = this.diagnosis.symptomsName + '；'
        this.diagnosisTemp.symptomsCode = this.diagnosis.symptomsCode = this.diagnosis.symptomsCode + '；'
      }
      this.diagnosis.symptomsName = this.diagnosisTemp.symptomsName
      this.diagnosis.symptomsCode = this.diagnosisTemp.symptomsCode
    },
    deleteSymptoms(e) {
      if (e.keyCode == 8) {
        const o = this.diagnosis.symptomsName.split('；')
        const p = this.diagnosis.symptomsCode.split('；')
        o.splice(o.length - 2, 2)
        p.splice(p.length - 2, 2)
        let n = o.length >= 1 ? o.join("；") + '；' : o.join("；")
        let s = p.length >= 1 ? p.join("；") + '；' : p.join("；")
        this.diagnosis.symptomsName = this.diagnosisTemp.symptomsName = n
        this.diagnosis.symptomsCode = this.diagnosisTemp.symptomsCode = s
      }
    },
    //提交门诊病历
    async submit() {
      let info = this.info
      let option = {
        id: info.id,
        birthday: this.birthday,
        outpatientTime: info.ddxx.obj.czsj,
        outpatientType: this.outpatientType,
        diagnosisCode: this.diagnosis.diagnosisCode,
        diagnosisName: this.diagnosis.diagnosisName,
        symptomsName: this.diagnosis.symptomsName,
        // symptomsCode: this.diagnosis.symptomsCode,
        allergyHistory: this.allergyHistory,
        diseaseDescription: this.diseaseDescription,
        nowHistory: this.nowHistory,
        pastHistory: this.pastHistory
      }
      let {code} = await this.$http("smarthos.online.outpatient.medical.submit", option)
      if (code === '0') {
        this.$message.success('提交成功');
        this.diagnosis = {
          diagnosisCode: '',
          diagnosisName: '',
          symptomsCode: '',
          symptomsName: '',
        }
        this.diagnosisTemp = {
          diagnosisCode: '',
          diagnosisName: '',
          symptomsCode: '',
          symptomsName: '',
        }
        this.allergyHistory = ''
        this.outpatientType = '1'
        this.diseaseDescription = ''
        this.nowHistory = ''
        this.pastHistory = ''
        this.dialogFormVisible = false
        this.close()
      }
    },
    show() {
      this.dialogFormVisible = true;
    },
    close() {
      this.dialogFormVisible = false;
    },
  },
  watch: {
    datas: {
      handler(newV) {
        this.info = newV
        // console.log('【newV】', newV, this.info)
        if (this.disabled) {
          this.initHisRecord()
        }
      },
      immediate: true
    },
    inputDisabled: {
      handler(newV) {
        this.disabled = newV
      },
      immediate: true
    },
  }
}
</script>

<style scoped lang="scss">
.addMain {
  li {
    margin-top: 20px;
  }
}

.addRecord {
  .el-input .el-input--large {
    width: 10%;
  }
}

.dash {
  border-top: 1px dashed #f1f1f1;
  height: 15px;
}

</style>
